module.exports = __webpack_public_path__ + "assets/img/boss.b440271b.png";